import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import { partQuery } from "#modules/parts/infra/part.query";
import { JobStatusType } from "shared";

import { PartDto } from "../infra/fetchPart.api";

export const usePart = (
  id: string | undefined,
  options?: {
    refetchInterval?: UseQueryOptions<PartDto>["refetchInterval"];
    enabled?: boolean;
    initialData?: PartDto;
  },
) => {
  const [initialFeaturesStatus, setInitialFeaturesStatus] = useState<JobStatusType | undefined>(
    undefined,
  );

  const { data, ...rest } = useQuery({
    ...partQuery(id),
    refetchInterval: options?.refetchInterval,
    enabled: options?.enabled,
    ...(options?.initialData !== undefined && { initialData: options.initialData }),
  });

  useEffect(() => {
    if (!initialFeaturesStatus) {
      setInitialFeaturesStatus(data?.featuresStatus);
    }
  }, [data?.featuresStatus, initialFeaturesStatus, setInitialFeaturesStatus]);

  return { part: data, ...rest };
};
